// extracted by mini-css-extract-plugin
export default {"banner":"banner--gt9sX","icon":"icon--gt9sX","text":"text--gt9sX"};